import Vue from 'vue';
/**
 * 引入 vue-photo-preview 安装插件
 * https://github.com/826327700/vue-photo-preview
 * https://photoswipe.com/documentation/options.html
 * 异步图片需调用this.$previewRefresh()
*/
import '~/static/lib/vue-photo-preview/skin.css'
if (process.client) {
  require('~/static/lib/vue-photo-preview')
  Vue.use(vuePhotoPreview, {
    fullscreenEl:false, //关闭全屏按钮
    loop:false
  })
}